import React, { FC, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../StyleSheet/MainComponent/FormDetails/BasicForms.scss";
import {
  SetActionsBasicFormsDetails,
  SetActiveTabs, ////---tab---active
  SetActionsBasicFormscreateDetails,
  SetActionsBasicFormsEditDetails,
  setPreviousDataFetchActions,
  setIDverifycationanotherapidatasActions, ///aadhar---front verified
  settheAadarFrontImageAsBase64, ////As Front Base 64 ,
  settheAadarFrontFiles, ///As front files ,
  setTheOnboardPhoneNumber, ///for get the phone number
  setTheOtherAAdhaarOtpPhoneNuberAction,
  setTheaadharsentOtpReportActions, ///submit the---aadhar--otps
  setAadhar_counts,
  setTheAadhar_front_count,
  setTheAadharFristNumbers,
  setTheSumbitOtpFormsAadhar_verified,
  getDenaveStateDataRequest,
} from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import { Grid, Typography } from "@material-ui/core";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Button from "@mui/material/Button";
import { colors } from "@mui/material";
import { data } from "jquery";
import ImageUploader from "./ImagerUpload";
import Select from "react-select";
import { store } from "../../../Redux/Store";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";
import { set } from "lodash";

const BasicForms = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const organization = useSelector(
    (state) => state.NumberCounts.selectedOnoardClient,
  );

  console.log(organization, "dkaslkdklasdlklka");

  const fileInputRef = useRef(null);

  const Swal = require("sweetalert2");
  const form_data = new FormData();
  const user_image = new FormData();
  const Navigate = useNavigate();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAdminEmails =
    state.SideBarFiles?.UserEmailID === "codoid@gmail.com" ||
    state.SideBarFiles?.UserEmailID === "admin@uds.in" ||
    state.SideBarFiles?.UserEmailID === "admin@gmail.com" ||
    state.SideBarFiles?.UserEmailID === "adminit@uds.in";

  const shouldMask =
    Boolean(state.EmployeeProfile?.EmployeeProfileList?.payroll_approved) &&
    !isAdminEmails;
  const initialState = {
    first_name: "",
    // last_name: "",
    email_id: "",
    phoneNum: "",
    placeofBirth: "",
    DateofBirth: "",
    user_image: "",
    genderErr: "",
    age: "",
    aadhar_number: "",
    aadhar_transaction_id: "",
    aadhar_count: "",
    aadhar_front_count: "",
    personal_identification_mark: "",
    religion: "",
    emergency_contact_number: "",
    blood_group: "",
    referral_number: "",
    city: "",
    state: "",
  };
  const [datas, setData] = useState(initialState);
  const [firsterro, setfirsterro] = useState("");
  const [lasterro, setlasterro] = useState("");
  const [emailerro, setEmailerro] = useState("");
  const [phoneerro, sphoneerro] = useState("");
  const [dateerro, setdateerro] = useState("");
  const [gendererror, setgendererror] = useState("");
  const [placeofBirtherr, setPlaceoferr] = useState("");
  const [sendIm, setImagest] = useState(false);
  const [profileErr, setProfleErr] = useState("");
  const [addharsent, setAadharsent] = useState(false);
  const [ActiveBtn, setActiveBtn] = useState(true);
  const [AregularBtn, setregularBtn] = useState(false);
  const [adharerr, setAdharErr] = useState("");
  const [EmergencyContact, setemergencyErr] = useState("");
  const [blopderr, setblodderr] = useState("");
  const [religionerr, setregliionerr] = useState("");
  const [employementTypeErr, setEmployementTypeErr] = useState("");
  const [employementCategoryErr, setEmployementCategoryErr] = useState("");
  const [cityErr, setCityErr] = useState("");
  const [stateErr, setStateErr] = useState("");
  const [refarralNumErr, setReferralNumErr] = useState("");

  const [BloddGroupvalue, setbloodgroupval] = useState({
    value: "",
    label: "select",
  });
  const [religionval, setreligionval] = useState({
    value: "",
    label: "select",
  });
  const [employementType, setEmployementType] = useState();
  const [employeeCategory, setEmployeeCategory] = useState();

  const [profileFiles, setprofileIFile] = useState();
  const [aadhaarFiles, setaadhaarFile] = useState();
  const fileInputAadhaar = useRef(null);
  const [EmailID, setEmailID] = useState("");
  const UserData = useSelector((state) => state.users.UserData.data);
  const [PresentUrls, setPresentUrls] = useState([]);
  const [denaveStateList, setDenaveStateList] = useState([]);
  const [denaveCityList, setDenaveCityList] = useState([]);
  const [PresentUrlsProfile, setpresenturlProfile] = useState({
    ProfileUrls: "",
  });
  const [PresentUrlsAadhar, setpresenturlAadhar] = useState({
    aadhaarUrl: "",
  });

  const { denaveStateData } = useSelector((state) => state.denaveStateGetData);
  const [forindex, setforindex] = useState();

  useEffect(() => {
    if (UserData != undefined) {
      if (
        UserData.admin_access != undefined &&
        UserData.admin_access != "" &&
        UserData.admin_access != null &&
        UserData.admin_access != undefined
      ) {
        setEmailID(UserData.email);
      }
    }
  }, [state.users.UserData.data]);
  useEffect(() => {
    if (
      organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
    ) {
      const payload = {
        request_type: "state",
        country: "India",
      };
      dispatch(getDenaveStateDataRequest(payload));
    }
  }, []);
  useEffect(() => {
    if (datas?.state) {
      console.log(data?.state, "daskdkaskdlklsa");
      const payload = {
        request_type: "city",
        country: "India",
        state: datas?.state,
      };
      setTimeout(() => {
        dispatch(getDenaveStateDataRequest(payload));
      }, 500);
    }
  }, [datas?.state]);
  useEffect(() => {
    if (denaveStateData?.data?.state?.length > 0) {
      console.log(denaveStateData, "jkaskjdjkajkdjak");

      setDenaveStateList(
        denaveStateData?.data?.state?.map((item) => ({
          value: item,
          label: item,
        })),
      );
    } else if (denaveStateData?.data?.city?.length > 0) {
      setDenaveCityList(
        denaveStateData?.data?.city?.map((item) => ({
          value: item,
          label: item,
        })),
      );
    }
  }, [denaveStateData]);

  const style = {
    btn: {
      background: ActiveBtn ? "#ef4d39" : "white",
      color: ActiveBtn ? "white" : "#000",
      border: ActiveBtn ? " 2px solid #fff" : "2px solid #F05639",
    },

    regularbtn: {
      background: AregularBtn ? "#ef4d39" : "white",
      color: AregularBtn ? "white" : "#000",
      border: AregularBtn ? "2px solid #fff" : " 2px solid #F05639",
    },
  };
  const [sendotp, setsendotp] = useState(false);

  const aadhaarformData = new FormData();
  const [count, setCount] = useState(0); // Initialize count with one_mark
  const [aadharFrontCount, setAAdharfrontCout] = useState(0);
  const [Email, setEmail] = useState("");
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const GenderList = {
    Male: false,
    Female: false,
    other: false,
  };
  const [ForGender, SetGender] = useState(GenderList);
  const [image, setImage] = useState();
  ///---Age---------
  const [birthDate, setBirthDate] = useState("");
  const [age, setAge] = useState("");

  const initialStateCrop = {
    unit: "%", // Can be 'px' or '%'
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  };
  const [crop, setCrop] = useState();

  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);

  const SubmitedForm = new FormData();
  const [url, setUrl] = useState();
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [imgfile2, setimgfile2] = useState();
  const [urlsign, setUrlsign] = useState();

  const muiltiplefiles = {
    file1: "",
    file2: "",
    file3: "",
  };

  const [numberoffiles, setfiles] = useState(muiltiplefiles);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [file, setFile] = useState([]);
  const [LastN, setLastN] = useState({ name: "", lastname: "" });

  const Blood_Group = [
    { value: "A +ve", label: "A +ve" },
    { value: "A -ve", label: "A -ve" },
    { value: "B +ve", label: "B +ve" },
    { value: "B -ve", label: "B -ve" },
    { value: "AB +ve", label: "AB +ve" },
    { value: "AB -ve", label: "AB -ve" },
    { value: "O +ve", label: "O +ve" },
    { value: "O -ve", label: "O -ve" },
    { value: "Rh +ve", label: "Rh +ve" },
    { value: "Rh -ve", label: "Rh -ve" },
    { value: "A1 +ve", label: "A1 +ve" },
    { value: "A1 -ve", label: "A1 -ve" },
    { value: "B1 +ve", label: "B1 +ve" },
    { value: "B1 -ve", label: "B1 -ve" },
    { value: "A1B +ve", label: "A1B +ve" },
    { value: "A1B -ve", label: "A1B -ve" },
  ];
  const religion = [
    { value: "HINDU", label: "HINDU" },
    { value: "MUSLIM", label: "MUSLIM" },
    { value: "CHRISTIAN", label: "CHRISTIAN" },
    { value: "JAIN", label: "JAIN" },
    { value: "BUDDHIST", label: "BUDDHIST" },
    { value: "OTHER", label: "OTHER" },
  ];
  const employementTypeOptions = [
    { label: "Permanent", value: "0" },
    { label: "Contractual", value: "1" },
    { label: "Consultant", value: "2" },
    { label: "Freelancer", value: "3" },
    { label: "Intern", value: "4" },
    { label: "Apprenticeship", value: "5" },
  ];
  const athenaEmployementTypeOptions = [

    { label: "Apprenticeship", value: "5" },
    { label: "Normal", value: "6" },

  ];
  const employementCategoryOptions = [
    { label: "FOS", value: "0" },
    { label: "Non FOS", value: "1" },
    { label: "Non FOS - Tele", value: "2" },
    { label: "Apprentice", value: "3" },
  ];

  const [OTPS, setOTPS] = useState("");

  const [aahdaFrontCount, setAadharfrontCard] = useState(0); // Initialize count with one_mark

  const [Validations, setValidations] = useState(0);
  var FirstName;
  var LastName;

  const preventTyping = (e) => {
    e.preventDefault();
  };

  const inputRef = useRef(null);
  // const preventZoom = (event) => {

  //   if (event.ctrlKey || event.metaKey) {
  //     event.preventDefault();
  //   }

  //   if (event?.type  =="wheel") {
  //     event.preventDefault();
  //   }

  //    if (["e", "E", "+", "-", "."].includes(event.key)) {
  //     event.preventDefault();
  // }
  // if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
  //   event.preventDefault();
  // }
  // };

  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }

    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");

    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, "");

    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  const incrementCount = () => {
    setCount(count + 1);
    // dispatch(setAadhar_counts(count + 1));
  };

  const AadharFront_cunts = () => {
    setAAdharfrontCout(aadharFrontCount + 1);

    // dispatch(
    //   setTheAadhar_front_count(
    //     aadharFrontCount + 1
    //   )
    // );
  };
  const Panverifed = () => {
    setAadharfrontCard(aahdaFrontCount + 1);
    setData({
      ...datas,
      aadhar_front_count: aahdaFrontCount,
    });
  };

  // const customStyles = {
  //   // menu: (provided, state) => ({
  //   //   ...provided,
  //   //   height: '200px',
  //   //   overflowY: 'auto',
  //   // }),

  // };

  const handleOTPChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value.slice(0, 1);
    if (index < otp.length - 1 && e.target.value !== "") {
      const nextInput = e.target.nextSibling;
      if (nextInput) {
        nextInput.focus();
      }
    }

    setOtp(newOtp);
    // setOTPS(newOtp)
    var otpVal;
    let newOtpVal = newOtp.filter((char) => char !== "").join("");
    setOTPS(newOtpVal);
    // console.log(otpVal, "otpVal" , newOtp , OTPS);
  };
  // ////---Aadhar---Retieve---datas,,,
  useEffect(() => {
    if (
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != null &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != ""
    ) {
      const name =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toLowerCase();
      const nameParts = name.split(" ");
      FirstName = nameParts[0];
      LastName = nameParts[1];
    }

    if (
      // AregularBtn &&
      // urlsign
      state.aadharsentSubmitthephoneotp.aadharsentotpsubmit != undefined &&
      state.aadharsentSubmitthephoneotp.aadharsentotpsubmit != null &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != null &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != ""
    ) {
      const [day, month, year] =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob != undefined &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob != null &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob.split("/");
      const formattedDOB = `${year}-${month}-${day}`;
      const AadharNumber =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.aadhar_id.replace(
          /\s/g,
          "",
        );

      const name =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toLowerCase();
      const nameParts = name.split(" ");
      FirstName = nameParts[0];
      LastName = nameParts[1];
      // setLastN(
      //   {
      //     ...LastN ,
      //     name:nameParts[0],
      //     lastname:nameParts[1]
      //   }
      // );

      console.log(
        state.idverfiyicationapidatas.AAdharFrontImagesDatas,
        "AadharNumber",
        state.idverfiyicationapidatas.FirstAadharNumber,
      );
      setData({
        ...datas,
        first_name:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toUpperCase(),
        // last_name: LastName,
        last_name: "",

        DateofBirth: formattedDOB,
        gender: state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender,

        aadhar_number:
          state.idverfiyicationapidatas.FirstAadharNumber != ""
            ? state.idverfiyicationapidatas.FirstAadharNumber
            : "",
      });
      setAge("");
      calculateAge();

      SetGender({
        ...ForGender,

        Male:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender == "Male",
        Female:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender ==
          "Female",
        other:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender ==
          "Others",
      });

      if (!urlsign) {
        setData({
          ...datas,
          first_name: "",
          DateofBirth: "",
          gender: "",

          aadhar_number: "",
        });
      }
    }

    if (
      // !AregularBtn &&
      // urlsign &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != null &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != ""
    ) {
      const [day, month, year] =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob != undefined &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob != null &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob.split("/");
      const formattedDOB = `${year}-${month}-${day}`;
      const AadharNumber =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.aadhar_id.replace(
          /\s/g,
          "",
        );
      console.log(formattedDOB, "AadharNumber", datas);
      setData({
        ...datas,
        // first_name: state.idverfiyicationapidatas.AAdharFrontImagesDatas.name,
        // DateofBirth: formattedDOB,
        // gender: state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender,

        aadhar_number:
          state.idverfiyicationapidatas.FirstAadharNumber != ""
            ? state.idverfiyicationapidatas.FirstAadharNumber
            : "",
      });

      // setAge("");
      // calculateAge();
      // SetGender({
      //   ...ForGender,

      //   Male:
      //     state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender == "Male",
      //   Female:
      //     state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender ==
      //     "Female",
      //   other:
      //     state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender ==
      //     "Others",
      // });

      if (!urlsign) {
        setData({
          ...datas,
          first_name: "",
          DateofBirth: "",
          gender: "",

          aadhar_number: "",
        });
      }
    }

    if (
      AregularBtn &&
      urlsign &&
      // state.aadharsentSubmitthephoneotp.aadharsentotpsubmit != undefined &&
      // state.aadharsentSubmitthephoneotp.aadharsentotpsubmit != null &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != null &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != ""
    ) {
      const [day, month, year] =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob != undefined &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob != null &&
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob.split("/");
      const formattedDOB = `${year}-${month}-${day}`;
      const AadharNumber =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.aadhar_id.replace(
          /\s/g,
          "",
        );
      console.log(month, day, "38742837409", year);

      if (
        (state.FormsIDList.ActiveTabs == 1 &&
          datas.aadhar_number != "" &&
          month == undefined) ||
        day == "" ||
        (year == " " && datas.DateofBirth.includes("undefined"))
      ) {
        toast.error(` ${"Please Upload Valid Aadhaar Image"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      const name =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toUpperCase();
      const nameParts = name.split(" ");
      FirstName = nameParts[0];
      LastName = nameParts[1];
      setData({
        ...datas,
        first_name: name,
        // last_name: LastName,
        DateofBirth: formattedDOB,
        gender: state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender,

        aadhar_number:
          state.idverfiyicationapidatas.FirstAadharNumber != ""
            ? state.idverfiyicationapidatas.FirstAadharNumber
            : "",
      });
      setAge("");

      calculateAge();

      SetGender({
        ...ForGender,

        Male:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender == "Male",
        Female:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender ==
          "Female",
        other:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender ==
          "Others",
      });

      if (!urlsign) {
        setData({
          ...datas,
          first_name: "",
          DateofBirth: "",
          gender: "",

          aadhar_number: "",
        });
      }
    }

    if (state.idverfiyicationapidatas.Error == "NA") {
      setUrlsign("");
    }

    if (
      state.FormsIDList.BasicFormID == "" &&
      sendotp &&
      ActiveBtn &&
      urlsign &&
      state.AadharOtherPartyAPIPhoneOtp.Client_id != undefined &&
      state.AadharOtherPartyAPIPhoneOtp.Client_id != null &&
      state.AadharOtherPartyAPIPhoneOtp.Client_id != ""
    ) {
      const name =
        state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toLowerCase();
      const nameParts = name.split(" ");
      setLastN({
        ...LastN,
        name: nameParts[0],
        lastname: nameParts[1],
      });
      // setData({
      //   ...datas,
      //   first_name: LastN.name,
      //   last_name: LastN.lastname,
      //   DateofBirth: "",
      //   gender: state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender,

      //   aadhar_number:
      //     state.idverfiyicationapidatas.FirstAadharNumber != ""
      //       ? state.idverfiyicationapidatas.FirstAadharNumber
      //       : "",
      //       client_id:
      //       state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
      //     role_id:
      //       state.NumberCounts.EmployeeRoleId, ///role----id

      // });
    }
  }, [
    state.idverfiyicationapidatas.AAdharFrontImagesDatas,
    state.aadharsentSubmitthephoneotp.aadharsentotpsubmit,
    // urlsign,
    // AregularBtn,

    sendotp,
    ActiveBtn,
    urlsign,
    state.AadharOtherPartyAPIPhoneOtp.Client_id,

    state.idverfiyicationapidatas.Error,
  ]);

  useEffect(() => {
    calculateAge();
  }, [datas.DateofBirth]);

  function calculateAge() {
    setAge("");
    if (!datas.DateofBirth.includes("undefined")) {
      console.log(datas.DateofBirth, "data.datas.DateofBirth.");
      const today = new Date();
      const birthDate = new Date(datas.DateofBirth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      setAge(age);
    }
  }

  useEffect(() => {
    const isAgeVerificationRequired = age !== "" && age <= 17;

    if (isAgeVerificationRequired) {
      Swal.fire({
        title: "Age Verification Required",
        text: "You must be 18 or older to proceed with this Onboarding process.",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "rgb(255 0 0)",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
        confirmButtonText: "Proceed",
      }).then((result) => {
        if (result.isConfirmed) {
          if (state.SideBarFiles.SideBarFile === "My Onboarding List") {
            navigate("/myonboarding");
          } else if (state.SideBarFiles.SideBarFile === "Approve Request") {
            navigate("/approverequestemp");
          } else if (state.SideBarFiles.SideBarFile === "Client") {
            navigate("/clientDetails");
          } else if (state.SideBarFiles.SideBarFile === "Onboarding") {
            navigate("/fieldagent");
          }
        }
      });
    } else {
      // ✅ handle age > 58 logic
      if (age !== "" && age > 58) {
        Swal.fire({
          title: "Date of Birth Mismatch",
          text: "The entered date of birth indicates age over 58, which is not allowed for this onboarding.",
          icon: "error",
          confirmButtonColor: "rgb(255 0 0)",
          allowOutsideClick: false,
          confirmButtonText: "Okay",
        });
      }
    }
  }, [age, state.SideBarFiles.SideBarFile, datas.DateofBirth, datas]);

  // ///--------------------Previous----API----
  // useEffect(()=>{
  //    const payload ={
  //     type:"BIF"
  //    }
  //   dispatch(setPreviousDataFetchActions(payload))
  // },[])

  const fixedCropSize = { width: 300, height: 200 };
  //  console.log(crop , "8707jyuiycrop");
  const cancel = (e) => {
    setalert(true);

    // setImageField("");
    setUrl("");
  };

  const HandleChanges = (e) => {
    if (e.target.name == "phoneNum") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value.slice(0, 10),
      });
    } else if (e.target.name == "gender") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value,
      });
    }

    if (e.target.name == "email_id") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value,
      });
    }

    if (e.target.name == "personal_identification_mark") {
      const { name, value } = e.target;
      setData({
        ...datas,
        [name]: value,
      });
    }
    if (e.target.name == "aadhar_number") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value.slice(0, 12),
      });
    } else if (
      e.target.name != "gender" &&
      e.target.name != "phoneNum" &&
      e.target.name != "aadhar_number"
    ) {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value.toUpperCase(),
      });
    }
  };
  useEffect(() => {
    if (
      state.FormsIDList.BasicFormID != undefined &&
      state.FormsIDList.ActiveTabs == 1
    ) {
      let payload = {
        Retieveid: state.FormsIDList.BasicFormID,
      };
      dispatch(SetActionsBasicFormsDetails(payload));

      console.log(state.FormsIDList.ActiveTabs, "state.FormsIDList.ActiveTabs");
    }
  }, [state.FormsIDList.ActiveTabs]);

  useEffect(() => {
    if (
      state.FormsSDETAILS.BasciForm.id != undefined &&
      state.FormsIDList.BasicFormID == state.FormsSDETAILS.BasciForm.id &&
      state.FormsIDList.BasicFormID != ""
    ) {
      console.log(state?.FormsSDETAILS, "daskjjdakjdjkakjdkjasdka");
      setData({
        ...datas,
        first_name: state.FormsSDETAILS.BasciForm.first_name,
        // last_name: state.FormsSDETAILS.BasciForm.last_name,
        phoneNum: state.FormsSDETAILS.BasciForm.phone_number,
        state: state.FormsSDETAILS.BasciForm.state,
        city: state.FormsSDETAILS.BasciForm.city,
        email_id: state.FormsSDETAILS.BasciForm.email_id,
        placeofBirth: state.FormsSDETAILS.BasciForm.place_of_birth,
        DateofBirth: state.FormsSDETAILS.BasciForm.date_of_birth,
        gender: state.FormsSDETAILS.BasciForm.gender,
        aadhar_number:
          state.FormsSDETAILS.BasciForm.aadhar_number != null
            ? state.FormsSDETAILS.BasciForm.aadhar_number
            : "",
        blood_group: state.FormsSDETAILS.BasciForm.blood_group,
        employee_category: state.FormsSDETAILS.BasciForm.employee_category,
        employee_type: state.FormsSDETAILS.BasciForm.employee_type,
        referral_number: state.FormsSDETAILS.BasciForm.referral_number,
        religion: state.FormsSDETAILS.BasciForm.religion,
        emergency_contact_number:
          state.FormsSDETAILS.BasciForm.emergency_contact_number,
        personal_identification_mark: state.FormsSDETAILS.BasciForm
          .personal_identification_mark
          ? state.FormsSDETAILS.BasciForm.personal_identification_mark[0]
          : "",
      });
      // console.log(state.FormsSDETAILS.BasciForm ,"asBasciForm");

      dispatch(
        setTheAadharFristNumbers(state.FormsSDETAILS.BasciForm.aadhar_number),
      );
      setfirsterro("");
      setEmailerro("");
      setdateerro("");
      sphoneerro("");

      if (state.FormsSDETAILS.BasciForm.religion) {
        // setbloodgroupval
        religion.map((item) => {
          // console.log(item , "epiwrweor", state.FormsSDETAILS.BasciForm.religion);
          if (
            item.value.toUpperCase() ==
            state.FormsSDETAILS.BasciForm.religion.toUpperCase()
          ) {
            setreligionval({
              value: item.value.toUpperCase(),
              label: item.value.toUpperCase(),
            });
          }
        });
      }
      if (state.FormsSDETAILS.BasciForm.employee_type) {
        let employeeMentType = state.FormsSDETAILS.BasciForm.employee_type;
        setEmployementType({
          label:
            employeeMentType == "0"
              ? "Permanent"
              : employeeMentType == "1"
                ? "Contractual"
                : employeeMentType == "2"
                  ? "Consultant"
                  : employeeMentType == "3"
                    ? "Freelancer"
                    : employeeMentType == "4"
                      ? "Intern"
                      : employeeMentType == "5"
                        ? "Apprenticeship"
                        : employeeMentType == "6"
                          ? "Normal"
                          : employeeMentType == "7"
                            ? "Support"
                            : employeeMentType == "8"
                              ? "Executive"
                              : "",
          value: state.FormsSDETAILS.BasciForm.employee_type,
        });
      }
      if (state.FormsSDETAILS.BasciForm.employee_category) {
        let employeeMentType = state.FormsSDETAILS.BasciForm.employee_category;
        setEmployeeCategory({
          label:
            state.FormsSDETAILS.BasciForm.employee_category == "0"
              ? "FOS"
              : state.FormsSDETAILS.BasciForm.employee_category == "1"
                ? "Non FOS"
                : state.FormsSDETAILS.BasciForm.employee_category == "2"
                  ? "Non FOS - Tele"
                  : state.FormsSDETAILS.BasciForm.employee_category == "3"
                    ? "Apprenticeship"
                    : "",
          value: state.FormsSDETAILS.BasciForm.employee_category,
        });
      }

      if (state.FormsSDETAILS.BasciForm.blood_group) {
        const rawBg = state.FormsSDETAILS.BasciForm.blood_group;
        const normalizeBg = (str) =>
          String(str || "")
            .trim()
            .toUpperCase()
            .replace(/POSITIVE/g, "+")
            .replace(/NEGATIVE/g, "-")
            .replace(/\s*\+VE/g, "+")
            .replace(/\s*-VE/g, "-")
            .replace(/\s+/g, "");

        const normalizedApiBg = normalizeBg(rawBg);
        let matched = Blood_Group.find(
          (item) => normalizeBg(item.value) === normalizedApiBg
        );

        if (matched) {
          setbloodgroupval({
            value: matched.value,
            label: matched.label,
          });
        } else {
          setbloodgroupval({
            value: rawBg,
            label: rawBg,
          });
        }
      }
      setgendererror("");

      setEmail(
        state.FormsSDETAILS.BasciForm.email_id != "" &&
          state.FormsSDETAILS.BasciForm.email_id != undefined &&
          state.FormsSDETAILS.BasciForm.email_id != null
          ? state.FormsSDETAILS.BasciForm.email_id
          : "",
      );

      if (
        state.FormsSDETAILS.BasciForm.finance_data != undefined &&
        state.FormsSDETAILS.BasciForm.finance_data != null &&
        state.FormsSDETAILS.BasciForm.finance_data[0]
      ) {
        const round =
          state.FormsSDETAILS.BasciForm.finance_data[0].aadhar_count;

        setCount(Math.round(round));

        dispatch(
          setAadhar_counts(
            state.FormsSDETAILS.BasciForm.finance_data[0].aadhar_count,
          ),
        );
        dispatch(
          setTheAadhar_front_count(
            state.FormsSDETAILS.BasciForm.finance_data[0].aadhar_front_count,
          ),
        );
        const Aadharfront =
          state.FormsSDETAILS.BasciForm.finance_data[0].aadhar_front_count;
        setAAdharfrontCout(Math.round(Aadharfront));
      }
      if (state.FormsSDETAILS.BasciForm.user_image != undefined) {
        setImage(state.FormsSDETAILS.BasciForm.user_image.media_url);
        setUrl(state.FormsSDETAILS.BasciForm.user_image.media_url);
        setImagest(false);
        setProfleErr("");
        setpresenturlProfile({
          ...PresentUrlsProfile,
          ProfileUrls: state.FormsSDETAILS.BasciForm.user_image.media_url,
        });
      }

      if (
        state.FormsSDETAILS.BasciForm.aadhar_front != undefined &&
        state.FormsSDETAILS.BasciForm.aadhar_front != null
      ) {
        setUrlsign(state.FormsSDETAILS.BasciForm.aadhar_front.media_url);
        setAadharsent(false);
        setAdharErr("");
        setpresenturlAadhar({
          ...PresentUrlsAadhar,
          aadhaarUrl: state.FormsSDETAILS.BasciForm.aadhar_front.media_url,
        });
      }

      const today = new Date();
      const dob = new Date(datas.DateofBirth);
      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dob.getDate())
      ) {
        age--;
      }

      setAge(age);
    }
  }, [state.FormsSDETAILS.BasciForm]);

  useEffect(() => {
    if (
      state.FormsSDETAILS.BasciForm.id != undefined &&
      state.FormsIDList.BasicFormID == state.FormsSDETAILS.BasciForm.id &&
      state.FormsIDList.BasicFormID != ""
    ) {
      const today = new Date();
      const dob = new Date(state.FormsSDETAILS.BasciForm.date_of_birth);
      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dob.getDate())
      ) {
        age--;
      }
      setAge(age);
    }
  }, [state.FormsSDETAILS.BasciForm]);

  useEffect(() => {
    if (
      state.FormsSDETAILS.BasciForm.id != undefined &&
      state.FormsIDList.BasicFormID == state.FormsSDETAILS.BasciForm.id &&
      state.FormsIDList.BasicFormID != ""
    ) {
      // console.log(state.FormsSDETAILS.BasciForm.gender.toLowerCase(), "gender");
      if (state.FormsSDETAILS.BasciForm.gender.toLowerCase() == "male") {
        SetGender({
          ...ForGender,
          Male: true,
        });
      } else if (
        state.FormsSDETAILS.BasciForm.gender.toLowerCase() == "female"
      ) {
        SetGender({
          ...ForGender,
          Female: true,
        });
      } else if (
        state.FormsSDETAILS.BasciForm.gender.toLowerCase() == "others"
      ) {
        SetGender({
          ...ForGender,
          other: true,
        });
      }
    }
  }, [state.FormsSDETAILS.BasciForm]);
  // ----------------------Profiles-----------------------------
  const getCroppedImg = (imageRef, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        // const croppedFile = new File([blob], fileName, {
        //   type: "image/jpeg",
        // });
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        console.log(croppedFile, "qw89croppedFile");
        var file = croppedFile;
        if (CroppImageViewCount == 1) {
          setFile(croppedFile);
          var reader = new FileReader();
          reader.onloadend = function () {
            setUrl(reader.result);
          };
          reader.readAsDataURL(file);
          if (croppedFile) {
            // setTimeout(() => {
            setCroppImageView(false);

            // }, 0);
            const generateRandomNumber = () => {
              return Math.floor(Math.random() * 100000);
            };

            const createPresentData = (croppedFile) => {
              const randomNumber = generateRandomNumber();
              const formattedFilename = `onboarding/${CroppImageViewCount == 1 ? "user_image" : "aadharfront"}/${CroppImageViewCount == 1 ? `user_image${randomNumber}` : `aadharfront${randomNumber}`}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
              const Presentdata = {
                multiple_files: [
                  {
                    filename: formattedFilename,
                    file_type: croppedFile.type,
                  },
                ],
              };

              return Presentdata;
            };

            const Presentdata = createPresentData(croppedFile);
            console.log(Presentdata, "sdsasd Presentdata");

            axios({
              url: PresentUrl,
              method: "post",
              data: Presentdata,
              headers: {
                Authorization:
                  "Bearer " + store.getState().users.UserData.session.token,
              },
            })
              .then((response) => {
                console.log("Files uploaded successfully:", response.data);
                const uploadedFiles = response.data.data; // Adjust based on actual response structure
                console.log(uploadedFiles, "uploadedFiles");

                const newUrls = uploadedFiles.map((file) => ({
                  url: file, // Adjust this based on the actual response
                  type: croppedFile.type,
                  putfiles: croppedFile,
                }));

                setPresentUrls((prevUrls) => {
                  const updatedUrls = [...prevUrls];
                  updatedUrls[forindex] = newUrls[0];
                  return updatedUrls;
                });
                setpresenturlProfile({
                  ProfileUrls: String(response.data.data).split("?")[0],
                });
              })
              .catch((error) => {
                console.error("Error uploading files:", error);
              });
          }
        } else if (CroppImageViewCount == 2) {
          setfiles({
            ...numberoffiles,
            file2: croppedFile,
          });
          setimgfile2(croppedFile);
          // console.log(croppedFile, "croppedFile");
          if (croppedFile) {
            setTimeout(() => {
              setCroppImageView(false);
            }, 0);
          }

          var file = croppedFile;
          var reader = new FileReader();
          ////another ---api
          // setaadharFrontfile(croppedFile);

          ///setIDverifycationanotherapidatasActions -------
          reader.onloadend = function () {
            dispatch(settheAadarFrontImageAsBase64(reader.result)); /// As Base64
            setUrlsign(reader.result);
          };
          reader.readAsDataURL(file);
          setCroppImageView(false);

          if (croppedFile) {
            aadhaarformData.append("aadhar_card", croppedFile);
            const generateRandomNumber = () => {
              return Math.floor(Math.random() * 100000);
            };

            const createPresentData = (croppedFile) => {
              const randomNumber = generateRandomNumber();
              const formattedFilename = `onboarding/${CroppImageViewCount == 1 ? "user_image" : "aadharfront"}/${CroppImageViewCount == 1 ? `user_image${randomNumber}` : `aadharfront${randomNumber}`}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
              const Presentdata = {
                multiple_files: [
                  {
                    filename: formattedFilename,
                    file_type: croppedFile.type,
                  },
                ],
              };

              return Presentdata;
            };

            const Presentdata = createPresentData(croppedFile);
            axios({
              url: PresentUrl,
              method: "post",
              data: Presentdata,
              headers: {
                Authorization:
                  "Bearer " + store.getState().users.UserData.session.token,
              },
            })
              .then((response) => {
                console.log("Files uploaded successfully:", response.data);
                const uploadedFiles = response.data.data; // Adjust based on actual response structure
                console.log(uploadedFiles, "uploadedFiles");

                const newUrls = uploadedFiles.map((file) => ({
                  url: file, // Adjust this based on the actual response
                  type: croppedFile.type,
                  putfiles: croppedFile,
                }));

                // Update PresentUrls state
                setPresentUrls((prevUrls) => {
                  const updatedUrls = [...prevUrls];
                  updatedUrls[forindex] = newUrls[0];
                  return updatedUrls;
                });

                setpresenturlAadhar({
                  aadhaarUrl: String(response.data.data).split("?")[0],
                });
              })
              .catch((error) => {
                console.error("Error uploading files:", error);
              });

            const payload = {
              fromdata: aadhaarformData,
              Imagetype: 1,
            };
            dispatch(setIDverifycationanotherapidatasActions(payload));
            incrementCount();
            dispatch(
              setTheAadhar_front_count(
                state.OnboardngCounts.aadhar_front_count + 1,
              ),
            );
            blob.name = fileName;
          }
        }
        resolve(croppedFile);
      }, "image/jpeg");
    });
  };

  const updateAvatar = (imgSrc) => {
    if (CroppImageViewCount == 1) {
      // fileInputRef.current = imgSrc;
      fileInputRef.current.value = imgSrc;
    } else if (CroppImageViewCount == 2) {
      fileInputAadhaar.current.value = imgSrc;
    }
  };

  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
    // const file = e.target.files[0];

    // setCroppImageView(false)

    // if (file && file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    //    console.log(file ,"0827301983902");

    //   toast.error(` File size should be less than ${MAX_FILE_SIZE_MB}  MB`, {
    //     position: toast.POSITION.TOP_RIGHT,
    //   });

    //   return;
    // }
    // const reader = new FileReader();
    // reader.onload = () => {
    //   imgRef.current.src = reader.result;
    // };
    // reader.readAsDataURL(file);
  };

  const setCompletedCrop = async (c) => {
    // console.log(c, "newfile.jpeg", imgRef.current);
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };
  const handleFiles = (e) => {
    setImagest(true);
    setShowCropper(true);
    setProfleErr("");
    // selectedImage(e);
    setCroppImageViewCount(1);
    setCroppImageView(true);
    setprofileIFile(e);
    setalert(true);
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;
    setforindex(1);

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(e);
          });
        });
        reader.readAsDataURL(file);
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
    }
  };

  const handleFiles2 = (e) => {
    setAadharsent(true);

    setCroppImageViewCount(2);
    setCroppImageView(true);
    setAdharErr("");
    setalert(true);
    setaadhaarFile(e);
    // selectedImage(e);
    const file = e.target.files[0];
    console.log(file, "file");
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;

    setforindex(0);

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(e);
          });
        });
        reader.readAsDataURL(file);
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
    }
  };

  const cancel2 = (e) => {
    setalert(true);
    setUrlsign("");

    setfiles({
      ...numberoffiles,
      file2: "",
    });
  };
  let datasd = {
    first_name: datas.first_name.trim().toUpperCase(),
    last_name: "",
    gender: datas.gender,
    date_of_birth: datas.DateofBirth,
    place_of_birth: datas.placeofBirth,
    email_id: Email,
    phone_number: datas.phoneNum,
    state: datas.state,
    city: datas.city,
    client_id: state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
    role_id: state.NumberCounts.EmployeeRoleId, ///role----id
    aadhar_number: datas.aadhar_number,
    aadhar_count: state.OnboardngCounts.aadhar_count,
    aadhar_front_count: state.OnboardngCounts.aadhar_front_count,
    aadhar_transaction_id: "",
    personal_identification_mark: [datas.personal_identification_mark],
    religion: datas.religion,
    emergency_contact_number: datas.emergency_contact_number,
    blood_group: datas.blood_group,
    user_image: PresentUrlsProfile.ProfileUrls,
    aadhar_front: PresentUrlsAadhar.aadhaarUrl,
  };

  /////--------------------------NEXT____FUNCTION--------------------------
  const HandleNext = (e) => {
    var a = 0;

    if (
      state.FormsIDList.BasicFormID != "" &&
      state.FormsSDETAILS.BasciForm != undefined
    ) {
      var personalIdentificationMark =
        state.FormsSDETAILS.BasciForm.personal_identification_mark;
      var isPersonalIdentificationMarkEqual = personalIdentificationMark
        ? personalIdentificationMark.length > 0
          ? datas.personal_identification_mark === personalIdentificationMark[0]
          : datas.personal_identification_mark === ""
        : datas.personal_identification_mark === "";

      // Normalize and compare user image URL
      var normalizedUrl = url?.trim().toLowerCase();
      var userImageMediaUrl =
        state.FormsSDETAILS.BasciForm.user_image?.media_url || "";
      var normalizedUserImageMediaUrl = userImageMediaUrl?.trim().toLowerCase();
      var isUserImageUrlEqual = normalizedUrl === normalizedUserImageMediaUrl;

      // Normalize and compare Aadhar front media URL
      var normalizedUrlSign = urlsign?.trim().toLowerCase();
      var userAadhaaMediaUrl =
        state.FormsSDETAILS.BasciForm.aadhar_front?.media_url ||
        "<default_url_or_empty>";
      var normalizedUserAadhaaMediaUrl = userAadhaaMediaUrl
        ?.trim()
        .toLowerCase();
      var isUserAadharUrlEqual =
        normalizedUrlSign === normalizedUserAadhaaMediaUrl;
    }

    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item) => {
          try {
            if (item != undefined && item != null) {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });

              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }

              const data = await response.json();
              console.log("Files uploaded successfully:", data);
              setUrlsign(PresentUrlsAadhar.aadhaarUrl);
              setUrl(PresentUrlsProfile.ProfileUrls);
            }
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        }),
      );
    };

    if (
      state.FormsIDList.BasicFormID == "" &&
      state.FormsSDETAILS.BasciForm == ""
    ) {
      let CreateDatas = {
        first_name: datas.first_name.trim().toUpperCase(),
        last_name: "",
        gender: datas.gender,
        date_of_birth: datas.DateofBirth,
        place_of_birth: datas.placeofBirth,
        email_id: Email,
        phone_number: datas.phoneNum,
        state: datas.state,
        city: datas.city,
        country: "India",
        client_id: state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
        role_id: state.NumberCounts.EmployeeRoleId, ///role----id
        aadhar_number: datas.aadhar_number,
        aadhar_count: state.OnboardngCounts.aadhar_count,
        aadhar_front_count: state.OnboardngCounts.aadhar_front_count,
        aadhar_transaction_id: "",
        personal_identification_mark: [datas.personal_identification_mark],
        religion: datas.religion,
        emergency_contact_number: datas.emergency_contact_number,
        blood_group: datas.blood_group,
        user_image: PresentUrlsProfile.ProfileUrls,
        aadhar_front: PresentUrlsAadhar.aadhaarUrl,
        employee_type: datas.employee_type,
        referral_number: datas.referral_number,
        employee_category: datas.employee_category,
      };
      if (url == undefined || url == null || url == "") {
        setProfleErr("*Profile image is required");
        a = 1;
      }

      // if (addharsent) {
      if (urlsign == undefined || urlsign == null || urlsign == "") {
        setAdharErr("*Aadhaar image is required");
        a = 1;
      }

      if (
        datas.emergency_contact_number == null ||
        datas.emergency_contact_number == "" ||
        datas.emergency_contact_number == null ||
        datas.emergency_contact_number == undefined
      ) {
        setemergencyErr("*Emergency Contact is required");
        a = 1;
      }
      if (
        datas.religion == "" ||
        datas.religion == undefined ||
        datas.religion == null
      ) {
        a = 1;
        setregliionerr("*Religion is required");
      }
      // if (
      //   datas.referral_number == "" ||
      //   datas.referral_number == undefined ||
      //   datas.referral_number == null
      // ) {
      //   a = 1;
      //   setReferralNumErr("*Referral number is required");
      // }
      if (
        (datas.employee_type == "" ||
          datas.employee_type == undefined ||
          datas.employee_type == null) &&
        (organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e" ||
          organization?.organization?.id == "28e108e0-a644-4365-89df-317867f00f22")
      ) {
        a = 1;
        setEmployementTypeErr("*Employment type is required");
      }
      if (
        (datas.employee_category == "" ||
          datas.employee_category == undefined ||
          datas.employee_category == null) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setEmployementCategoryErr("*Employment category is required");
      }
      if (
        (datas.state == "" ||
          datas.state == undefined ||
          datas.state == null) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setStateErr("*State is required");
      }
      if (
        (datas.city == "" || datas.city == undefined || datas.city == null) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setCityErr("*City is required");
      }

      if (datas.first_name == "") {
        a = 1;
        setfirsterro("*Name is required");
      }
      if (Email != "" && Email != null && !validator.isEmail(Email)) {
        setEmailerro("*Enter valid mail id");
        a = 1;
      }

      if (datas.DateofBirth == "" || datas.DateofBirth.includes("undefined")) {
        a = 1;
        setdateerro("*Date of birth is required");
      }

      if (datas.phoneNum == "") {
        a = 1;
        sphoneerro("*Phone Number  is required");
      }

      if (datas.phoneNum != "" && datas.phoneNum.length < 10) {
        a = 1;
        sphoneerro("*Phone Number  should not less than 10 digits");
      }

      if (datas.phoneNum != "" && datas.phoneNum.length > 10) {
        a = 1;
        sphoneerro("*Phone Number should not  greater than 10 digits");
      }

      if (datas.gender == "" || datas.gender == undefined) {
        a = 1;
        setgendererror("*Gender is required");
      }

      if (
        datas.blood_group == "" ||
        datas.blood_group == null ||
        datas.blood_group == undefined
      ) {
        setblodderr("*Blood group is required");
        a = 1;
      }
      if (
        datas.emergency_contact_number != "" &&
        datas.emergency_contact_number != null &&
        datas.emergency_contact_number != undefined &&
        datas.emergency_contact_number != null &&
        datas.emergency_contact_number.length < 10
      ) {
        setemergencyErr("*Emergency contact should not less than 10 digits");
        a = 1;
      }

      if (
        datas.emergency_contact_number != null &&
        datas.emergency_contact_number != "" &&
        datas.emergency_contact_number.length > 10
      ) {
        a = 1;
        sphoneerro("*Emergency contact should not  greater than 10 digits");
      }

      if (
        a == 0 &&
        Validations == 0 &&
        (sendIm == true || addharsent == true)
      ) {
        fetchUploadFiles();
      }

      if (a == 0) {
        const payload = {
          form_data: CreateDatas,
          Retieveid: state.FormsIDList.BasicFormID,
          Move: 2,
        };
        dispatch(SetActionsBasicFormscreateDetails(payload));
        setPresentUrls([]);
        dispatch(setTheOnboardPhoneNumber(datas.phoneNum));
      }
    }

    if (
      state.FormsIDList.BasicFormID != "" &&
      state.FormsSDETAILS.BasciForm != ""
    ) {
      if (
        datas.email_id != "" &&
        datas.email_id != null &&
        !validator.isEmail(datas.email_id)
      ) {
        setEmailerro("*Enter valid mail id");
        a = 1;
      }

      if (datas.first_name == "") {
        a = 1;
        setfirsterro("*Name is required");
      }
      if (
        datas.emergency_contact_number == "" ||
        datas.emergency_contact_number == null ||
        datas.emergency_contact_number == undefined
      ) {
        setemergencyErr("*Emergency Contact is required");
        a = 1;
      }

      if (
        datas.emergency_contact_number != "" &&
        datas.emergency_contact_number != undefined &&
        datas.emergency_contact_number != null &&
        datas.emergency_contact_number.length > 10
      ) {
        a = 1;
        sphoneerro("*Emergency contact should not greater than 10 digits");
      }

      if (
        datas.DateofBirth == "" ||
        datas.DateofBirth == undefined ||
        datas.DateofBirth.includes("undefined")
      ) {
        a = 1;
        setdateerro("*Date of birth is required");
      }

      if (
        datas.blood_group == "" ||
        datas.blood_group == null ||
        datas.blood_group == undefined
      ) {
        setblodderr("*Blood group is required");
        a = 1;
      }

      if (
        datas.religion == "" ||
        datas.religion == null ||
        datas.religion == undefined
      ) {
        a = 1;
        setregliionerr("*Religion is required");
      }
      // if (
      //   datas.referral_number == "" ||
      //   datas.referral_number == undefined ||
      //   datas.referral_number == null
      // ) {
      //   a = 1;
      //   setReferralNumErr("*Referral number is required");
      // }
      if (
        (datas.employee_type == "" ||
          datas.employee_type == undefined ||
          datas.employee_type == null) &&
        (organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e" ||
          organization?.organization?.id == "28e108e0-a644-4365-89df-317867f00f22")
      ) {
        a = 1;
        setEmployementTypeErr("*Employment type is required");
      }
      if (
        (datas.employee_category == "" ||
          datas.employee_category == undefined ||
          datas.employee_category == null) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setEmployementCategoryErr("*Employment category is required");
      }
      if (
        (datas.state == "" ||
          datas.state == undefined ||
          datas.state == null) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setStateErr("*State is required");
      }
      if (
        (datas.city == "" || datas.city == undefined || datas.city == null) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setCityErr("*City is required");
      }

      if (
        datas.phoneNum == "" ||
        datas.phoneNum == undefined ||
        datas.phoneNum == null
      ) {
        a = 1;
        sphoneerro("*Phone Number is required");
      }

      if (
        datas.phoneNum != "" &&
        datas.phoneNum != undefined &&
        datas.phoneNum != null &&
        datas.phoneNum.length < 10
      ) {
        a = 1;
        sphoneerro("*Phone Number should not less than 10 digits");
      }

      if (
        datas.emergency_contact_number != "" &&
        datas.emergency_contact_number != null &&
        datas.emergency_contact_number != undefined &&
        datas.emergency_contact_number != null &&
        datas.emergency_contact_number.length < 10
      ) {
        setemergencyErr("*Emergency contact should not less than 10 digits");

        a = 1;
      }

      if (
        datas.phoneNum != "" &&
        datas.phoneNum != undefined &&
        datas.phoneNum != null &&
        datas.phoneNum.length > 10
      ) {
        a = 1;
        sphoneerro("*Phone Number should not  greater than 10 digits");
      }

      if (datas.gender == "" || datas.gender == undefined) {
        a = 1;
        setgendererror("*Gender is required");
      }
      // if (datas.placeofBirth == "") {
      //   a = 1;
      //   setPlaceoferr("*place of birth is required");
      // }
      // if (!sendIm) {
      if (url == undefined || url == null || url == "") {
        setProfleErr("*Profile image is required");
        a = 1;
      }

      // if (addharsent) {
      if (urlsign == undefined || urlsign == null || urlsign == "") {
        setAdharErr("*Aadhaar image is required");
        a = 1;
      }
    }

    if (
      a == 0 &&
      state.FormsIDList.BasicFormID !== "" &&
      state.FormsIDList.BasicFormID === state.FormsSDETAILS.BasciForm.id &&
      (datas.first_name !== state.FormsSDETAILS.BasciForm.first_name ||
        datas.phoneNum !== state.FormsSDETAILS.BasciForm.phone_number ||
        datas.state !== state.FormsSDETAILS.BasciForm.state ||
        datas.city !== state.FormsSDETAILS.BasciForm.city ||
        datas.email_id !== state.FormsSDETAILS.BasciForm.email_id ||
        datas.placeofBirth !== state.FormsSDETAILS.BasciForm.place_of_birth ||
        datas.DateofBirth !== state.FormsSDETAILS.BasciForm.date_of_birth ||
        datas.aadhar_number !== state.FormsSDETAILS.BasciForm.aadhar_number ||
        datas.employee_category !==
        state.FormsSDETAILS.BasciForm.employee_category ||
        datas.employee_type !== state.FormsSDETAILS.BasciForm.employee_type ||
        datas.referral_number !==
        state.FormsSDETAILS.BasciForm.referral_number ||
        datas.gender !== state.FormsSDETAILS.BasciForm.gender ||
        !isUserImageUrlEqual || // Compare user image URLs
        !isUserAadharUrlEqual || // Compare Aadhar URLs
        datas.blood_group !== state.FormsSDETAILS.BasciForm.blood_group ||
        datas.emergency_contact_number !==
        state.FormsSDETAILS.BasciForm.emergency_contact_number ||
        !isPersonalIdentificationMarkEqual)
    ) {
      if (
        a == 0 &&
        Validations == 0 &&
        (sendIm == true || addharsent == true)
      ) {
        fetchUploadFiles();
      }

      if (a == 0 && Validations == 0) {
        let NormalData = {
          first_name: datas.first_name.trim().toUpperCase(),
          last_name: "",

          gender: datas.gender,
          date_of_birth: datas.DateofBirth,
          place_of_birth: datas.placeofBirth,
          email_id:
            datas.email_id != null && datas.email_id != undefined
              ? datas.email_id.toLowerCase().trim()
              : null,
          phone_number: datas.phoneNum,
          state: datas.state,
          city: datas.city,
          country: "India",
          client_id: state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
          role_id: state.NumberCounts.EmployeeRoleId, ///role----id
          aadhar_number: datas.aadhar_number,
          aadhar_count: state.OnboardngCounts.aadhar_count,
          aadhar_front_count: state.OnboardngCounts.aadhar_front_count,
          aadhar_transaction_id: "",
          personal_identification_mark: [datas.personal_identification_mark],
          religion: datas.religion,
          emergency_contact_number: datas.emergency_contact_number,
          blood_group: datas.blood_group,
          user_image: PresentUrlsProfile.ProfileUrls,
          aadhar_front: PresentUrlsAadhar.aadhaarUrl,
          employee_type: datas.employee_type,
          referral_number: datas.referral_number,
          employee_category: datas.employee_category,
        };
        // );

        if (sendIm) {
          form_data.append("user_image", file);
        }

        if (addharsent) {
          form_data.append("aadhar_front", imgfile2);
        }
        const payload = {
          // form_data: form_data,
          form_data: NormalData,
          user_image: user_image,
          Retieveid: state.FormsIDList.BasicFormID,
        };
        dispatch(setTheOnboardPhoneNumber(datas.phoneNum));

        dispatch(SetActionsBasicFormsEditDetails(payload));
        setPresentUrls([]);
      }
    }
    //
    // else

    if (
      a == 0 &&
      state.FormsIDList.BasicFormID !== "" &&
      // state.FormsSDETAILS.BasciForm !== [] &&
      datas.first_name === state.FormsSDETAILS.BasciForm.first_name &&
      datas.phoneNum === state.FormsSDETAILS.BasciForm.phone_number &&
      datas.email_id === state.FormsSDETAILS.BasciForm.email_id &&
      datas.DateofBirth === state.FormsSDETAILS.BasciForm.date_of_birth &&
      datas.gender === state.FormsSDETAILS.BasciForm.gender &&
      datas.placeofBirth === state.FormsSDETAILS.BasciForm.place_of_birth &&
      datas.aadhar_number == state.FormsSDETAILS.BasciForm.aadhar_number &&
      isUserImageUrlEqual && // Use the comparison result for user image URL
      isUserAadharUrlEqual && // Use the comparison result for Aadhar URL
      datas.blood_group === state.FormsSDETAILS.BasciForm.blood_group &&
      datas.emergency_contact_number ===
      state.FormsSDETAILS.BasciForm.emergency_contact_number &&
      isPersonalIdentificationMarkEqual
    ) {
      // console.log("tab");
      dispatch(SetActiveTabs(2));
      //
    }
  };

  console.log(
    state.NumberCounts.EmployeeFormFIll,
    state.FormsIDList.BasicFormID,
    "state.NumberCounts.EmployeeFormFIll",
    (state.NumberCounts.Editable == 2 || state.ClientBranchIDs.SUBROLE == 3) &&
    state.NumberCounts.EmployeeFormFIll == true,
  );

  return (
    <>
      <div className="">
        <div
        //className={stateDisplay ? " POPUP" : "outerPOPUP"}
        >
          <div className=" BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          <span>Basic Information</span>
                        </div>
                      </div>

                      <div className="Modal-Body ModalForms">
                        <div className="row">
                          <div
                            className="col-12 AadhaarSendotpVerified RoleButton"
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <button
                              className="btn aadharBtn"
                              variant="contained"
                              component="label"
                              // style={{ background: "#ef4d39" }}
                              style={style.btn}
                              onClick={(e) => {
                                dispatch(
                                  setTheSumbitOtpFormsAadhar_verified(true),
                                );

                                setActiveBtn(true);
                                setregularBtn(false);
                                if (state.NumberCounts.Editable == 2) {
                                  setData({
                                    ...datas,
                                    first_name: "",
                                    DateofBirth: "",
                                    gender: "",

                                    aadhar_number:
                                      state.idverfiyicationapidatas
                                        .FirstAadharNumber != ""
                                        ? state.idverfiyicationapidatas
                                          .FirstAadharNumber
                                        : "",
                                    phoneNum: "",
                                  });
                                  setAge("");
                                }
                              }}
                            >
                              UIDAI Verification
                            </button>
                            <button
                              className="btn aadharBtn "
                              variant="contained"
                              component="label"
                              // style={{ background: "#ef4d39" }}

                              style={style.regularbtn}
                              onClick={(e) => {
                                setActiveBtn(false);
                                setregularBtn(true);
                                dispatch(
                                  setTheSumbitOtpFormsAadhar_verified(false),
                                );
                                if (
                                  // url &&
                                  // state.idverfiyicationapidatas
                                  //   .AAdharFrontImagesDatas != undefined &&
                                  // state.idverfiyicationapidatas
                                  //   .AAdharFrontImagesDatas != null &&
                                  // state.idverfiyicationapidatas
                                  //   .AAdharFrontImagesDatas != ""
                                  state.idverfiyicationapidatas
                                    .AAdharFrontImagesDatas != undefined &&
                                  state.idverfiyicationapidatas
                                    .AAdharFrontImagesDatas != null &&
                                  state.idverfiyicationapidatas
                                    .AAdharFrontImagesDatas != ""
                                ) {
                                  const [day, month, year] =
                                    state.idverfiyicationapidatas
                                      .AAdharFrontImagesDatas != undefined &&
                                    state.idverfiyicationapidatas
                                      .AAdharFrontImagesDatas.dob !=
                                    undefined &&
                                    state.idverfiyicationapidatas
                                      .AAdharFrontImagesDatas.dob != null &&
                                    state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob.split(
                                      "/",
                                    );
                                  const formattedDOB = `${year}-${month}-${day}`;
                                  const AadharNumber =
                                    state.idverfiyicationapidatas.AAdharFrontImagesDatas.aadhar_id.replace(
                                      /\s/g,
                                      "",
                                    );
                                  setData({
                                    ...datas,
                                    first_name:
                                      state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toUpperCase(),
                                    // first_name: FirstName,
                                    // last_name: LastName,
                                    last_name: "",
                                    DateofBirth: formattedDOB,
                                    gender:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender,

                                    aadhar_number:
                                      state.idverfiyicationapidatas
                                        .FirstAadharNumber != ""
                                        ? state.idverfiyicationapidatas
                                          .FirstAadharNumber
                                        : "",
                                  });
                                  SetGender({
                                    ...ForGender,

                                    Male:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender ==
                                      "Male",
                                    Female:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender ==
                                      "Female",
                                    other:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender ==
                                      "Others",
                                  });
                                }
                              }}
                            >
                              Manual Verification
                            </button>
                          </div>

                          {/* ----Aadhar---Card-----Front----Images----------------- */}
                          {/* 
                          {
                          state.NumberCounts.Editable != 1 ||
                          state.ClientBranchIDs.SUBROLE == 3 ? ( */}
                          <div class="col-6 mt-4">
                            <div>
                              <small style={{ color: "red" }}>
                                {/* Note: Please upload the image . Ensure that
                                  the file is a minimum of 10 MB in size and is
                                  in JPG, JPEG or PNG format. */}
                                Note:Upload the pictures, please. Verify that
                                the file is in the JPG, JPEG, or PNG format and
                                that its size is less than 10 MB.
                              </small>
                            </div>
                            <>
                              <label
                                style={{
                                  margin: 0,
                                  padding: 10,
                                  width: "100%",
                                  display: "block",
                                }}
                                className="form-label"
                              >
                                Aadhaar Front image
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </>

                            <>
                              {urlsign ? (
                                <>
                                  <img
                                    src={urlsign}
                                    className="pointer"
                                    onClick={(e) => {
                                      if (state.NumberCounts.Editable == 1) {
                                        window.open(urlsign);
                                      }
                                    }}
                                    style={{
                                      // height: 115,
                                      // width: 115,
                                      // marginRight: 25,
                                      // borderRadius: "50%",
                                      height: "153px",
                                      width: "198px",
                                      margin: "25px",

                                      border: "1px solid #000",

                                      marginRight: "25",
                                    }}
                                    alt="Image"
                                  />
                                </>
                              ) : (
                                <>
                                  {/* <p
                                      style={{
                                        margin: 0,
                                        padding: 10,
                                        width: "200px",
                                      }}
                                    >
                                      Aadhaar Front image
                                      {state.NumberCounts.Editable == 1 ? (
                                        ""
                                      ) : (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                      <small style={{ color: "red" }}>
                                        Note:Images only Supported
                                      </small>
                                    </p> */}
                                </>
                              )}

                              {!urlsign ? (
                                <>
                                  {/* <Button
                                      className=" doctorupload"
                                      variant="contained"
                                      component="label"
                                      style={{
                                        background: "#ef4d39",
                                        color: "white",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <p>
                                        Upload Image
                                        <input
                                          type="file"
                                          hidden
                                          disabled={
                                            state.NumberCounts.Editable == 1
                                              ? true
                                              : false
                                          }
                                          accept="image/png, image/jpeg"
                                          onChange={(e) => handleFiles2(e)}
                                        />
                                      </p>
                                    </Button> */}
                                  <Button
                                    className="btn doctorupload"
                                    variant="contained"
                                    component="label"
                                    style={{
                                      background: "#ef4d39",
                                      color: "#fff",
                                      fontSize: "11px !important",
                                    }}
                                  >
                                    <input
                                      type="file"
                                      hidden
                                      disabled={
                                        state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                      accept="image/png, image/jpeg"
                                      onChange={(e) => handleFiles2(e)}
                                      ref={fileInputAadhaar}
                                    />
                                    Upload Image
                                  </Button>
                                </>
                              ) : null}

                              {
                                // state.idverfiyicationapidatas
                                //   .Idverificationanotherapidatas != [] &&

                                urlsign ? (
                                  <>
                                    <Button
                                      className=" remove doctorupload"
                                      variant="contained"
                                      onClick={(e) => {
                                        cancel2(e);
                                        setData({
                                          ...data,
                                          aadhar_number: "",
                                          first_name: "",
                                          // last_name: "",
                                          email_id: "",
                                          phoneNum: "",
                                          placeofBirth: "",
                                          DateofBirth: "",
                                          emergency_contact_number: "",
                                          blood_group: "",
                                          religion: "",
                                          personal_identification_mark: "",
                                        });
                                        setAadharsent(false);

                                        setbloodgroupval({});
                                        setreligionval({});
                                      }}
                                      style={{
                                        background: "#ef4d39",
                                        color: "white",
                                        fontSize: "11px !important",
                                      }}
                                      disabled={
                                        state.NumberCounts.Editable == 1 &&
                                          EmailID != "admin@gmail.com" &&
                                          EmailID != "adminit@uds.in" &&
                                          EmailID != "codoid@gmail.com" &&
                                          EmailID != "admin@uds.in"
                                          ? true
                                          : false
                                      }
                                    >
                                      Remove Image
                                    </Button>
                                  </>
                                ) : (
                                  ""
                                )
                              }
                            </>
                            <p className="Error" style={{ marginTop: "3px" }}>
                              {adharerr}
                            </p>
                          </div>
                          {/* ) : null} */}

                          {/* <ImageUploader/> */}

                          {/* 
   -----------------------Profiles--------------------------------- */}

                          <div className="col-6 mt-3">
                            <label
                              for="validationCustom01"
                              class="form-label"
                              style={{ width: "100%" }}
                            >
                              Profile
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            {url ? (
                              <img
                                src={url}
                                onClick={(e) => {
                                  if (state.NumberCounts.Editable == 1) {
                                    window.open(url);
                                  }
                                }}
                                className="pointer"
                                style={{
                                  // height: 115,
                                  // width: 115,
                                  height: "153px",
                                  width: "198px",
                                  margin: "25px",
                                  /* border-radius: 50%; */
                                  border: "1px solid #000",

                                  marginRight: "25",
                                  //borderRadius: "50%",
                                }}
                                alt="Image"
                              />
                            ) : // <p style={{ margin: 0, padding: 10 }}>
                              //   Upload Profile Picture
                              // </p>
                              null}

                            {!url ? (
                              <Button
                                className="btn doctorupload"
                                variant="contained"
                                component="label"
                                style={{
                                  background: "#ef4d39",
                                  color: "#fff",
                                  fontSize: "11px !important",
                                }}
                              >
                                <input
                                  type="file"
                                  hidden
                                  accept="image/png, image/jpeg"
                                  ref={fileInputRef}
                                  onChange={(e) => handleFiles(e)}
                                />
                                Upload Image
                              </Button>
                            ) : (
                              <></>
                            )}

                            {url ? (
                              <Button
                                className="btn remove doctorupload"
                                variant="contained"
                                onClick={(e) => {
                                  cancel(e);
                                  setImagest(false);
                                }}
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                    EmailID != "admin@gmail.com" &&
                                    EmailID != "adminit@uds.in" &&
                                    EmailID != "codoid@gmail.com" &&
                                    EmailID != "admin@uds.in"
                                    ? true
                                    : false
                                }
                              // style={{
                              //   background: "#ef4d39", color: "#fff",
                              //   fontSize:"11px !important"

                              //  }}
                              >
                                Remove Image
                              </Button>
                            ) : (
                              ""
                            )}
                            <p className="Error" style={{ marginTop: "3px" }}>
                              {profileErr}
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          {/* {state.NumberCounts.Editable != 1 ||
                          state.ClientBranchIDs.SUBROLE == 3 ? ( */}
                          <>
                            <div className="col-sm-3 mt-3 AAdharBox">
                              <div>
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Aadhaar Number
                                </label>
                                {/* {state.NumberCounts.Editable == 1 ? (
                                    ""
                                  ) : (
                                    <span style={{ color: "red" }}>*</span>
                                  )} */}
                                <span style={{ color: "red" }}>*</span>

                                <input
                                  type="text"
                                  class="form-control"
                                  required
                                  // disabled={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //   state.ClientBranchIDs.SUBROLE != 3
                                  //     ? true
                                  //     : false
                                  // }
                                  onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                                  onPaste={handlePaste} // Handle pasting
                                  onWheel={preventZoom} // Prevent zooming with the mouse wheel
                                  autocomplete="off"
                                  value={
                                    datas.aadhar_number
                                      ? shouldMask
                                        ? `**** **** ${datas.aadhar_number.toString().slice(-4)}`
                                        : datas.aadhar_number
                                      : ""
                                  }
                                  name="aadhar_number"
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      EmailID != "admin@gmail.com" &&
                                      EmailID != "adminit@uds.in" &&
                                      EmailID != "codoid@gmail.com" &&
                                      EmailID != "admin@uds.in"
                                      ? true
                                      : false
                                    // state.NumberCounts.Editable == 1 && EmailID != "admin@gmail.com" && EmailID != "adminit@uds.in" && EmailID != "codoid@gmail.com" && EmailID != "admin@uds.in"
                                    // ? true
                                    //   :
                                    //   state.NumberCounts.Editable == 2 ? true :
                                    //   false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                  }}
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                      EmailID != "admin@gmail.com" &&
                                      EmailID != "adminit@uds.in" &&
                                      EmailID != "codoid@gmail.com" &&
                                      EmailID != "admin@uds.in"
                                      ? true
                                      : false
                                  }
                                  onClick={(e) => {
                                    if (!urlsign) {
                                      toast.error(
                                        ` ${"Please upload aadha front Image"} `,
                                        {
                                          position: toast.POSITION.TOP_RIGHT,
                                        },
                                      );
                                    }
                                    // HandleChanges(e);
                                  }}
                                />
                              </div>
                              {!AregularBtn &&
                                //                             state.NumberCounts.Editable != 1 ||
                                //                                     state.EmployeeProfile.EmployeeProfileList != "" &&
                                //                                     state.EmployeeProfile.EmployeeProfileList.is_id_verification != null &&
                                //                                     state.EmployeeProfile.EmployeeProfileList.is_id_verification !=
                                //                                       undefined
                                //                                       &&
                                //                                       state.EmployeeProfile.EmployeeProfileList.is_id_verification === false
                                //                                       &&

                                //                                       state.aadharsentSubmitthephoneotp.SubmitValues == false  &&
                                //                           state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
                                // state.idverfiyicationapidatas.AAdharFrontImagesDatas != null &&
                                // state.idverfiyicationapidatas.AAdharFrontImagesDatas != "" &&
                                // ActiveBtn &&
                                // urlsign &&
                                state.NumberCounts.Editable == 2 &&
                                state.EmployeeProfile.EmployeeProfileList == "" &&
                                !sendotp &&
                                // state.EmployeeProfile.EmployeeProfileList.is_id_verification != null &&
                                // state.EmployeeProfile.EmployeeProfileList.is_id_verification !=
                                //   undefined &&
                                //   &&
                                //   state.EmployeeProfile.EmployeeProfileList.basic_info?.aadhar_verified == false
                                // &&

                                // state.aadharsentSubmitthephoneotp.SubmitValues == false  &&
                                state.idverfiyicationapidatas
                                  .AAdharFrontImagesDatas != undefined &&
                                state.idverfiyicationapidatas
                                  .AAdharFrontImagesDatas != null &&
                                state.idverfiyicationapidatas
                                  .AAdharFrontImagesDatas != "" &&
                                urlsign ? (
                                // state.ClientBranchIDs.SUBROLE == 3
                                // state.NumberCounts.Editable == 2
                                <Button
                                  className="doctorupload sendOtpBTTN"
                                  variant="contained"
                                  component="label"
                                  style={{
                                    background: "#ef4d39",
                                    color: "#fff",
                                    fontSize: "11px",
                                  }}
                                  onClick={(e) => {
                                    if (
                                      datas.aadhar_number != undefined &&
                                      datas.aadhar_number != null &&
                                      datas.aadhar_number != "" &&
                                      datas.aadhar_number != undefined
                                    ) {
                                      const aadhartop = {
                                        data: datas.aadhar_number,
                                      };
                                      setsendotp(true);

                                      dispatch(
                                        setTheOtherAAdhaarOtpPhoneNuberAction(
                                          aadhartop,
                                        ),
                                      );
                                      AadharFront_cunts();
                                      // dispatch(
                                      //   setTheAadhar_front_count(
                                      //     aadharFrontCount + 1
                                      //   )
                                      // );
                                      dispatch(
                                        setAadhar_counts(
                                          state.OnboardngCounts.aadhar_count +
                                          1,
                                        ),
                                      );
                                    }
                                  }}
                                >
                                  Send Otp
                                </Button>
                              ) : (
                                state.NumberCounts.Editable == 1 &&
                                state.EmployeeProfile.EmployeeProfileList !=
                                "" &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .is_id_verification != null &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .is_id_verification != undefined &&
                                state.ClientBranchIDs.SUBROLE == 3 && (
                                  <Button
                                    className="doctorupload sendOtpBTTN"
                                    variant="contained"
                                    component="label"
                                    style={{
                                      background: "#ef4d39",
                                      color: "#fff",
                                      fontSize: "11px",
                                    }}
                                    onClick={(e) => {
                                      if (
                                        datas.aadhar_number != undefined &&
                                        datas.aadhar_number != null &&
                                        datas.aadhar_number != "" &&
                                        datas.aadhar_number != undefined
                                      ) {
                                        const aadhartop = {
                                          data: datas.aadhar_number,
                                        };
                                        setsendotp(true);

                                        dispatch(
                                          setTheOtherAAdhaarOtpPhoneNuberAction(
                                            aadhartop,
                                          ),
                                        );
                                        AadharFront_cunts();
                                        // dispatch(
                                        //   setTheAadhar_front_count(
                                        //     aadharFrontCount + 1
                                        //   )
                                        // );
                                        dispatch(
                                          setAadhar_counts(
                                            state.OnboardngCounts.aadhar_count +
                                            1,
                                          ),
                                        );
                                      }
                                    }}
                                  >
                                    Send Otp
                                  </Button>
                                )
                              )}
                            </div>

                            {
                              // state.FormsIDList.BasicFormID == "" &&
                              sendotp &&
                                ActiveBtn &&
                                urlsign &&
                                state.AadharOtherPartyAPIPhoneOtp.Client_id !=
                                undefined &&
                                state.AadharOtherPartyAPIPhoneOtp.Client_id !=
                                null &&
                                state.AadharOtherPartyAPIPhoneOtp.Client_id !=
                                "" ? (
                                <div className="col-12 Outer-Input OuterOtpBox">
                                  <div className="otp-container">
                                    <div className="otp-input">
                                      {otp.map((digit, index) => (
                                        <input
                                          key={index}
                                          type="number"
                                          maxLength="1"
                                          className="OtpNumbers"
                                          value={digit}
                                          onChange={(e) => {
                                            handleOTPChange(e, index);
                                          }}
                                        />
                                      ))}
                                    </div>
                                  </div>

                                  <div className="sendOtpBTTN1">
                                    <Button
                                      className="doctorupload sendOtpBTTN1"
                                      variant="contained"
                                      component="label"
                                      style={{
                                        background: "#ef4d39",
                                        color: "#fff",
                                      }}
                                      // disabled={otp[5] != "" ? false : true}
                                      onClick={(e) => {
                                        const [day, month, year] =
                                          state.idverfiyicationapidatas
                                            .AAdharFrontImagesDatas !=
                                          undefined &&
                                          state.idverfiyicationapidatas
                                            .AAdharFrontImagesDatas.dob !=
                                          undefined &&
                                          state.idverfiyicationapidatas
                                            .AAdharFrontImagesDatas.dob !=
                                          null &&
                                          state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob.split(
                                            "/",
                                          );
                                        const formattedDOB = `${year}-${month}-${day}`;
                                        const fetchUploadFiles = async () => {
                                          await Promise.all(
                                            PresentUrls.map(async (item) => {
                                              try {
                                                if (
                                                  item != undefined &&
                                                  item != null
                                                ) {
                                                  const response = await fetch(
                                                    item.url,
                                                    {
                                                      method: "PUT",
                                                      headers: {
                                                        "Content-Type":
                                                          item.type,
                                                        "x-amz-acl":
                                                          "public-read",
                                                      },
                                                      body: item.putfiles,
                                                    },
                                                  );

                                                  if (!response.ok) {
                                                    throw new Error(
                                                      `HTTP error! Status: ${response.status}`,
                                                    );
                                                  }

                                                  const data =
                                                    await response.json();
                                                  console.log(
                                                    "Files uploaded successfully:",
                                                    data,
                                                  );
                                                  setUrlsign(
                                                    PresentUrlsAadhar.aadhaarUrl,
                                                  );
                                                  setUrl(
                                                    PresentUrlsProfile.ProfileUrls,
                                                  );
                                                }
                                              } catch (error) {
                                                console.error(
                                                  "Error uploading files:",
                                                  error,
                                                );
                                              }
                                            }),
                                          );
                                        };

                                        SubmitedForm.append(
                                          "data",
                                          JSON.stringify({
                                            first_name:
                                              state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toUpperCase(),
                                            // last_name: LastN,
                                            // first_name: FirstName,
                                            // last_name: LastName,
                                            //                                               nameParts != undefined && nameParts != null && nameParts[0],
                                            // last_name:nameParts != undefined && nameParts  != null && nameParts[1],

                                            date_of_birth: datas.DateofBirth,
                                            gender:
                                              state.idverfiyicationapidatas
                                                .AAdharFrontImagesDatas.gender,
                                            aadhar_number:
                                              state.idverfiyicationapidatas
                                                .FirstAadharNumber != ""
                                                ? state.idverfiyicationapidatas
                                                  .FirstAadharNumber
                                                : "",
                                            client_id:
                                              state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
                                            role_id:
                                              state.NumberCounts.EmployeeRoleId, ///role----id
                                            aadhar_count:
                                              state.OnboardngCounts
                                                .aadhar_count,
                                            aadhar_front_count:
                                              state.OnboardngCounts
                                                .aadhar_front_count,
                                            aadhar_transaction_id: "",
                                          }),
                                        );
                                        // SubmitedForm.append(
                                        //   "aadhar_front",
                                        //   imgfile2
                                        // );

                                        // if (sendIm) {
                                        //   SubmitedForm.append("user_image", file);
                                        // }
                                        // if(sendIm == true|| addharsent == true){
                                        //   fetchUploadFiles();
                                        //   // setUrlsign();
                                        //   // setUrl()

                                        // }
                                        if (
                                          state.AadharOtherPartyAPIPhoneOtp
                                            .Client_id != undefined &&
                                          state.AadharOtherPartyAPIPhoneOtp
                                            .Client_id != null &&
                                          state.AadharOtherPartyAPIPhoneOtp
                                            .Client_id != "" &&
                                          state.AadharOtherPartyAPIPhoneOtp
                                            .Client_id != undefined
                                        ) {
                                          const payload = {
                                            datas: {
                                              client_id:
                                                state
                                                  .AadharOtherPartyAPIPhoneOtp
                                                  .Client_id,
                                              otp: OTPS,
                                            },
                                            Id: state.FormsIDList.BasicFormID,
                                            // form_data: SubmitedForm,
                                            // Retieveid:
                                            //   state.FormsIDList.BasicFormID,
                                            basisdata: {
                                              first_name:
                                                state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toUpperCase(),
                                              date_of_birth: datas.DateofBirth,
                                              gender:
                                                state.idverfiyicationapidatas
                                                  .AAdharFrontImagesDatas
                                                  .gender,
                                              aadhar_number:
                                                state.idverfiyicationapidatas
                                                  .FirstAadharNumber != ""
                                                  ? state
                                                    .idverfiyicationapidatas
                                                    .FirstAadharNumber
                                                  : "",
                                              client_id:
                                                state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
                                              role_id:
                                                state.NumberCounts
                                                  .EmployeeRoleId, ///role----id
                                              aadhar_count:
                                                state.OnboardngCounts
                                                  .aadhar_count,
                                              aadhar_front_count:
                                                state.OnboardngCounts
                                                  .aadhar_front_count,
                                              aadhar_transaction_id: "",
                                              // email_id: datas.email_id,
                                              email_id: Email,
                                              blood_group: datas.blood_group,
                                              place_of_birth:
                                                datas.placeofBirth,
                                              religion: datas.religion,
                                              emergency_contact_number:
                                                datas.emergency_contact_number,
                                              personal_identification_mark: [
                                                datas.personal_identification_mark,
                                              ],
                                            },

                                            // aadhar_front: imgfile2,
                                            addharsent: addharsent,
                                            sendIm: sendIm,
                                            file: file,
                                            user_image:
                                              PresentUrlsProfile.ProfileUrls,
                                            aadhar_front:
                                              PresentUrlsAadhar.aadhaarUrl,

                                            Funcations: () => {
                                              fetchUploadFiles();
                                            },
                                          };
                                          dispatch(
                                            setTheaadharsentOtpReportActions(
                                              payload,
                                            ),
                                          );
                                          setsendotp(false);
                                        }

                                        // if (
                                        //   state.aadharsentSubmitthephoneotp
                                        //     .aadharsentotpsubmit
                                        // ) {
                                        //   // incrementCount();

                                        //   // setAAdharfrontCout(
                                        //   //   aadharFrontCount + 1
                                        //   // );

                                        //   // dispatch(setAadhar_counts(count + 1));

                                        //   dispatch(
                                        //     setTheAadhar_front_count(
                                        //       aadharFrontCount + 1
                                        //     )
                                        //   );
                                        // }
                                      }}
                                    >
                                      Submit
                                    </Button>

                                    <Button
                                      className="doctorupload sendOtpBTTN1"
                                      variant="contained"
                                      component="label"
                                      style={{
                                        background: "#ef4d39",
                                        color: "#fff",
                                      }}
                                      onClick={(e) => {
                                        if (
                                          datas.aadhar_number != undefined &&
                                          datas.aadhar_number != null &&
                                          datas.aadhar_number != "" &&
                                          datas.aadhar_number != undefined
                                        ) {
                                          const aadhartop = {
                                            data: datas.aadhar_number,
                                          };

                                          setOtp(["", "", "", "", "", ""]);

                                          dispatch(
                                            setTheOtherAAdhaarOtpPhoneNuberAction(
                                              aadhartop,
                                            ),
                                          );
                                        }
                                      }}
                                    >
                                      Resent OTP
                                    </Button>
                                  </div>
                                </div>
                              ) : null
                            }
                          </>
                          {/* // ) : null} */}
                        </div>
                        <div className="row">
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Name
                            </label>
                            {/* {state.NumberCounts.Editable == 1 ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )} */}
                            <span style={{ color: "red" }}>*</span>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="first_name"
                              // disabled={
                              //   state.NumberCounts.Editable == 1 && EmailID != "admin@gmail.com" && EmailID != "codoid@gmail.com" && EmailID != "admin@uds.in"
                              //     ? true
                              //     : false
                              // }
                              // readOnly={
                              //   state.NumberCounts.Editable == 1 && EmailID != "admin@gmail.com" && EmailID != "codoid@gmail.com" && EmailID != "admin@uds.in" &&
                              //   state.EmployeeProfile.EmployeeProfileList != ""
                              //     ? true
                              //     : false
                              // }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              value={datas.first_name}
                              onChange={(e) => {
                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                  setValidations(0);

                                  setfirsterro("");
                                } else {
                                  setValidations(1);
                                  setfirsterro(
                                    "First Name  should not exit  more than the 150 characters",
                                  );
                                }
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {firsterro}
                            </p>
                          </div>

                          {/* <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Last Name
                            </label>
                           
                            <input
                              type="text"
                              class="form-control"
                              required
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              autocomplete="off"
                              value={datas.last_name}
                              name="last_name"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                  setlasterro("");
                                  setValidations(0);
                                } else {
                                  setValidations(1);
                                  setlasterro(
                                    "Last Name  should not exit  more than the 150 characters"
                                  );
                                }
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {lasterro}
                            </p>
                          </div>
 */}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Phone Number
                            </label>
                            <span style={{ color: "red" }}>*</span>

                            <input
                              type={shouldMask ? "text" : "number"} // Changed from "number" to "text" to better control input
                              step="1"
                              onKeyDown={(evt) => {
                                preventZoom(evt);
                              }}
                              onPaste={(evt) => handlePaste(evt)} // Handle pasting
                              onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              className="form-control"
                              required
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              autoComplete="off"
                              value={
                                shouldMask && datas.phoneNum
                                  ? `******${String(datas.phoneNum).slice(-4)}`
                                  : datas.phoneNum
                              }
                              name="phoneNum"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                const value = e.target.value;

                                const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                sphoneerro("");
                                if (
                                  value.length <= 10 &&
                                  (phoneRegex.test(value) || value === "")
                                ) {
                                  HandleChanges(e);
                                }
                              }}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {phoneerro}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Emergency Contact
                            </label>
                            <span style={{ color: "red" }}>*</span>

                            <input
                              //  type="text" // Changed from "number" to "text" to better control input
                              step="1"
                              type={shouldMask ? "text" : "number"}
                              onKeyDown={(evt) => {
                                preventZoom(evt);
                              }}
                              onPaste={(evt) => handlePaste(evt)} // Handle pasting
                              onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              className="form-control"
                              required
                              value={
                                shouldMask && datas.emergency_contact_number
                                  ? `******${String(datas.emergency_contact_number).slice(-4)}`
                                  : datas.emergency_contact_number
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              autoComplete="off"
                              name="emergency_contact_number"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                const value = e.target.value;

                                const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                setemergencyErr("");
                                //  if(isNaN(e.target.value) ==  false){
                                if (
                                  value.length <= 10 &&
                                  (phoneRegex.test(value) || value === "")
                                ) {
                                  HandleChanges(e);
                                }
                                // }
                              }}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {EmergencyContact}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Email
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              autocomplete="off"
                              value={
                                datas.email_id != "" &&
                                  datas.email_id != null &&
                                  datas.email_id != undefined
                                  ? datas.email_id.toUpperCase()
                                  : ""
                              }
                              name="email_id"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setEmail(e.target.value);
                                setEmailerro("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {emailerro}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Gender
                            </label>
                            {/* {state.NumberCounts.Editable == 1 ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )} */}
                            <span style={{ color: "red" }}>*</span>

                            <div className="col">
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="Male"
                                  id="flexCheckDefault"
                                  name="gender"
                                  checked={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? ForGender.Male
                                      : datas.gender == "Male"
                                        ? true
                                        : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      EmailID != "admin@gmail.com" &&
                                      EmailID != "adminit@uds.in" &&
                                      EmailID != "codoid@gmail.com" &&
                                      EmailID != "admin@uds.in"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setgendererror("");
                                  }}
                                />
                                <label class="form-check-label">Male</label>
                              </div>
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="Female"
                                  id="flexCheckChecked"
                                  name="gender"
                                  checked={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? ForGender.Female
                                      : datas.gender == "Female"
                                        ? true
                                        : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      EmailID != "admin@gmail.com" &&
                                      EmailID != "adminit@uds.in" &&
                                      EmailID != "codoid@gmail.com" &&
                                      EmailID != "admin@uds.in"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                  }}
                                />
                                <label
                                  class="form-check-label"
                                  for="flexCheckChecked"
                                >
                                  Female
                                </label>
                              </div>
                              <div
                                class="form-check  d-inline "
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="Others"
                                  id="flexCheckChecked"
                                  name="gender"
                                  checked={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? ForGender.other
                                      : datas.gender == "Others"
                                        ? true
                                        : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      EmailID != "admin@gmail.com" &&
                                      EmailID != "adminit@uds.in" &&
                                      EmailID != "codoid@gmail.com" &&
                                      EmailID != "admin@uds.in"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                  }}
                                />
                                <label
                                  class="form-check-label"
                                  for="flexCheckChecked"
                                >
                                  other
                                </label>
                              </div>
                            </div>
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {gendererror}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Date of Birth
                            </label>
                            <span style={{ color: "red" }}>*</span>

                            <input
                              type={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? "text"
                                  : "date"
                              }
                              class="form-control"
                              required
                              autocomplete="off"
                              value={datas.DateofBirth}
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              name="DateofBirth"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              //  min={getMinimumDate()}
                              max={today} // Set the max attribute to today's date
                              onKeyDown={preventTyping}
                              onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                              // min="1955-01-01"
                              // max="2004-12-01"
                              onChange={(e) => {
                                setdateerro("");
                                HandleChanges(e);
                                setAge("");

                                setBirthDate(e.target.value);
                                calculateAge();
                              }}
                            />
                            {/* {state.NumberCounts.Editable == 1 ? null : ( */}
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {dateerro}
                            </p>
                            {/* )} */}
                          </div>
                          {datas.DateofBirth != "" &&
                            !datas.DateofBirth.includes("undefined") &&
                            datas.DateofBirth != undefined &&
                            datas.DateofBirth != null ? (
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Age
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                    EmailID != "admin@gmail.com" &&
                                    EmailID != "adminit@uds.in" &&
                                    EmailID != "codoid@gmail.com" &&
                                    EmailID != "admin@uds.in"
                                    ? true
                                    : false
                                }
                                required
                                autocomplete="off"
                                value={age}
                                name="age"
                                readOnly={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                              // onClick={calculateAge}
                              />
                            </div>
                          ) : null}

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Place Of Birth
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="placeofBirth"
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in" &&
                                  state.EmployeeProfile.EmployeeProfileList != ""
                                  ? true
                                  : false
                              }
                              value={datas.placeofBirth}
                              onChange={(e) => {
                                HandleChanges(e);
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3 BloodroupDropdown">
                            <label for="validationCustom01" class="form-label">
                              Blood group
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            <Select
                              //  styles={customStyles}
                              name="BranchSearch"
                              labelledBy="Select"
                              options={Blood_Group}
                              menuPlacement="top"
                              onChange={(e) => {
                                if (e != null) {
                                  setbloodgroupval(e);
                                  setData({
                                    ...datas,
                                    blood_group: e.label,
                                  });
                                } else {
                                  setData({
                                    ...datas,
                                    blood_group: "",
                                  });
                                  setbloodgroupval({
                                    value: "",
                                    label: "select",
                                  });
                                }
                                setblodderr("");
                              }}
                              value={BloddGroupvalue}
                              isDisabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in" &&
                                  state.EmployeeProfile.EmployeeProfileList != ""
                                  ? true
                                  : false
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {blopderr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Religion
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            <Select
                              menuPlacement="top"
                              onChange={(e) => {
                                if (e != null) {
                                  setreligionval(e);
                                  setData({
                                    ...datas,
                                    religion: e.label,
                                  });
                                } else {
                                  setData({
                                    ...datas,
                                    religion: "",
                                  });
                                  setreligionval({
                                    value: "",
                                    label: "select",
                                  });
                                }
                                setregliionerr("");
                              }}
                              isDisabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in" &&
                                  state.EmployeeProfile.EmployeeProfileList != ""
                                  ? true
                                  : false
                              }
                              name="BranchSearch"
                              labelledBy="Select"
                              options={religion}
                              value={religionval}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {religionerr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Personal Identification Mark
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="personal_identification_mark"
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in"
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "adminit@uds.in" &&
                                  EmailID != "codoid@gmail.com" &&
                                  EmailID != "admin@uds.in" &&
                                  state.EmployeeProfile.EmployeeProfileList != ""
                                  ? true
                                  : false
                              }
                              value={datas.personal_identification_mark}
                              onChange={(e) => {
                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                }
                              }}
                            />
                          </div>
                          {console.log(datas, "daldkldasldalksdklqwlk")}
                          {organization?.organization?.id ==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Employement Type
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  menuPlacement="top"
                                  onChange={(e) => {
                                    if (e != null) {
                                      setEmployementType(e);
                                      setData({
                                        ...datas,
                                        employee_type: e.value,
                                      });
                                    } else {
                                      setData({
                                        ...datas,
                                        employee_type: "",
                                      });
                                      setEmployementType({
                                        value: "",
                                        label: "select",
                                      });
                                    }
                                    setEmployementTypeErr("");
                                  }}
                                  // isDisabled={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in"
                                  //     ? true
                                  //     : false
                                  // }
                                  // readOnly={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in" &&
                                  //     state.EmployeeProfile.EmployeeProfileList !=
                                  //     ""
                                  //     ? true
                                  //     : false
                                  // }
                                  name="employee_type"
                                  labelledBy="Select"
                                  options={employementTypeOptions}
                                  value={employementType}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {employementTypeErr}
                                </p>
                              </div>
                            )}
                          {organization?.organization?.id ==
                            "28e108e0-a644-4365-89df-317867f00f22" && (
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Employement Type
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  menuPlacement="top"
                                  onChange={(e) => {
                                    if (e != null) {
                                      setEmployementType(e);
                                      setData({
                                        ...datas,
                                        employee_type: e.value,
                                      });
                                    } else {
                                      setData({
                                        ...datas,
                                        employee_type: "",
                                      });
                                      setEmployementType({
                                        value: "",
                                        label: "select",
                                      });
                                    }
                                    setEmployementTypeErr("");
                                  }}

                                  name="employee_type"
                                  labelledBy="Select"
                                  options={athenaEmployementTypeOptions}
                                  value={employementType}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {employementTypeErr}
                                </p>
                              </div>
                            )}

                          {organization?.organization?.id ==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Employee Catergory
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  menuPlacement="top"
                                  onChange={(e) => {
                                    if (e != null) {
                                      setEmployeeCategory(e);
                                      setData({
                                        ...datas,
                                        employee_category: e.value,
                                      });
                                    } else {
                                      setData({
                                        ...datas,
                                        employee_category: "",
                                      });
                                      setEmployeeCategory({
                                        value: "",
                                        label: "select",
                                      });
                                    }

                                    setEmployementCategoryErr("");
                                  }}
                                  // isDisabled={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in"
                                  //     ? true
                                  //     : false
                                  // }
                                  // readOnly={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in" &&
                                  //     state.EmployeeProfile.EmployeeProfileList !=
                                  //     ""
                                  //     ? true
                                  //     : false
                                  // }
                                  name="employee_category"
                                  labelledBy="Select"
                                  options={employementCategoryOptions}
                                  value={employeeCategory}
                                />
                                {console.log(state.NumberCounts, "djkasjkdajskda", state?.EmployeeProfile)}
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {employementCategoryErr}
                                </p>
                              </div>
                            )}
                          {organization?.organization?.id ==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  State
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  menuPlacement="top"
                                  onChange={(e) => {
                                    setData({
                                      ...datas,
                                      state: e.value,
                                      city: "",
                                    });
                                    setStateErr("");
                                  }}
                                  // isDisabled={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in"
                                  //     ? true
                                  //     : false
                                  // }
                                  // readOnly={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in" &&
                                  //     state.EmployeeProfile.EmployeeProfileList !=
                                  //     ""
                                  //     ? true
                                  //     : false
                                  // }
                                  name="employee_category"
                                  labelledBy="Select"
                                  options={denaveStateList}
                                  value={
                                    datas.state && {
                                      value: datas.state,
                                      label: datas.state,
                                    }
                                  }
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {stateErr}
                                </p>
                              </div>
                            )}
                          {organization?.organization?.id ==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  City
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  menuPlacement="top"
                                  onChange={(e) => {
                                    setData({
                                      ...datas,
                                      city: e.value,
                                    });
                                    setCityErr("");
                                  }}
                                  // isDisabled={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in"
                                  //     ? true
                                  //     : false
                                  // }
                                  // readOnly={
                                  //   state.NumberCounts.Editable == 1 &&
                                  //     EmailID != "admin@gmail.com" &&
                                  //     EmailID != "adminit@uds.in" &&
                                  //     EmailID != "codoid@gmail.com" &&
                                  //     EmailID != "admin@uds.in" &&
                                  //     state.EmployeeProfile.EmployeeProfileList !=
                                  //     ""
                                  //     ? true
                                  //     : false
                                  // }
                                  name="employee_category"
                                  labelledBy="Select"
                                  options={denaveCityList}
                                  value={
                                    datas.city && {
                                      value: datas.city,
                                      label: datas.city,
                                    }
                                  }
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {cityErr}
                                </p>
                              </div>
                            )}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Referral Number
                            </label>
                            {/* {state.NumberCounts.Editable == 1 ? (
                              ""
                            ) : (
                              )} */}
                            {/* <span style={{ color: "red" }}>*</span> */}

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="referral_number"
                              // disabled={
                              //   state.NumberCounts.Editable == 1 && EmailID != "admin@gmail.com" && EmailID != "codoid@gmail.com" && EmailID != "admin@uds.in"
                              //     ? true
                              //     : false
                              // }
                              // readOnly={
                              //   state.NumberCounts.Editable == 1 && EmailID != "admin@gmail.com" && EmailID != "codoid@gmail.com" && EmailID != "admin@uds.in" &&
                              //   state.EmployeeProfile.EmployeeProfileList != ""
                              //     ? true
                              //     : false
                              // }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              value={datas.referral_number}
                              onChange={(e) => {
                                // if (e.target.value.length < 150) {
                                HandleChanges(e);
                                setReferralNumErr("");
                                // } else {
                                //   setValidations(1);
                                //   setfirsterro(
                                //     "First Name  should not exit  more than the 150 characters",
                                //   );
                                // }
                              }}
                            />
                            {/* <p className="Error" style={{ marginLeft: "-5px" }}>
                              {refarralNumErr}
                            </p> */}
                          </div>
                        </div>
                      </div>
                      {state.NumberCounts.Editable == 2 ||
                        // state.ClientBranchIDs.SUBROLE == 3 ||
                        EmailID == "admin@gmail.com" ||
                        EmailID == "adminit@uds.in" ||
                        EmailID == "codoid@gmail.com" ||
                        EmailID == "admin@uds.in" ? (
                        <>
                          {state.NumberCounts.EmployeeFormFIll == true ? (
                            <div
                              className="RoleButton"
                              style={{
                                display: "flex",
                                gap: "15px",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                padding: "0px 15px",
                                marginBottom: "20px",
                              }}
                            >
                              <button
                                class="btn ButtonCSS"
                                style={{
                                  color: "#ffff",
                                  background: "#F26239",
                                }}
                                onClick={(e) => {
                                  HandleNext(e);
                                }}
                              >
                                Save & Continue
                              </button>
                            </div>
                          ) : (
                            <>
                              {state.FormsIDList.BasicFormID == "" ||
                                (state.FormsIDList.BasicFormID == null &&
                                  state.NumberCounts.EmployeeFormFIll ==
                                  false) ? (
                                <div
                                  className="RoleButton"
                                  style={{
                                    display: "flex",
                                    gap: "15px",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    padding: "0px 15px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <button
                                    class="btn ButtonCSS"
                                    style={{
                                      color: "#ffff",
                                      background: "#F26239",
                                    }}
                                    onClick={(e) => {
                                      HandleNext(e);
                                    }}
                                  >
                                    Save & Continue
                                  </button>
                                </div>
                              ) : (state.NumberCounts.Editable == 1 &&
                                // state.ClientBranchIDs.SUBROLE == 3 ||
                                EmailID == "admin@gmail.com") ||
                                EmailID == "adminit@uds.in" ||
                                EmailID == "codoid@gmail.com" ||
                                EmailID == "admin@uds.in" ? (
                                <div
                                  className="RoleButton"
                                  style={{
                                    display: "flex",
                                    gap: "15px",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    padding: "0px 15px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <button
                                    class="btn ButtonCSS"
                                    style={{
                                      color: "#ffff",
                                      background: "#F26239",
                                    }}
                                    onClick={(e) => {
                                      HandleNext(e);
                                    }}
                                  >
                                    Save & Continue
                                  </button>
                                </div>
                              ) : null}
                            </>
                          )}
                        </>
                      ) : (state.ClientBranchIDs.SUBROLE == 3 ||
                        state.ClientBranchIDs.SUBROLE == 0 ||
                        state.ClientBranchIDs.SUBROLE == 1) &&
                        state.NumberCounts.Editable == 1 &&
                        state.NumberCounts.EmployeeFormFIll == true ? (
                        <>
                          <div
                            className="RoleButton"
                            style={{
                              display: "flex",
                              gap: "15px",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              padding: "0px 15px",
                              marginBottom: "20px",
                            }}
                          >
                            <button
                              class="btn ButtonCSS"
                              style={{ color: "#ffff", background: "#F26239" }}
                              onClick={(e) => {
                                HandleNext(e);
                              }}
                            >
                              Save & Continue
                            </button>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={CroppImageViewCount == 1 ? profileFiles : aadhaarFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default BasicForms;
